import {categoryInformation} from './category-information-de.i18n';

export const de = {
  categoryInformation,
};
